allow-visible-on-all-workspaces:
  title: Межпространственная видимость
  description: Позволяет окну быть видимым на всех рабочих столах, только для macOS.
pages:
  modules:
    mcp-server:
      description: Возможность подключения и управления MCP сервером с инструментами
      title: MCP Сервер
  system:
    sections:
      section:
        window-shortcuts:
          title: Клавиши навигации окна
    window-shortcuts:
      description: Редактирование горячих клавиш для управления окном
      title: Горячие клавиши управления окном
      toggle-move:
        label: Перемещение окна
      toggle-resize:
        label: Масштабирование окна
      toggle-ignore-mouse-event:
        label: Игнорировать курсор мыши
      press-keys: Нажмите любую клавишу...
    developer:
      sections:
        section:
          use-window-mouse:
            title: useWindowMouse
            description: Test the Electron window cursor position
devtools:
  title: Developer
  pages:
    context-flow:
      title: Context Flow
    lag-visualizer:
      title: Lag Visualizer
    performance-visualizer:
      title: Performance Visualizer
      description: Toggle FPS/long task/memory overlay
    markdown-stress:
      title: Markdown Stress
      description: Stress markdown parsing and rendering with heavy chat payloads
    widgets-calling:
      title: Widget Calling
screen-capture:
  permissions-prompt:
    title: Screen Capture
    description: To capture screens or windows, screen and system audio recording permissions are required.
    open-preferences: Open System Preferences
    dismiss: Dismiss
    instructions:
      step-1: Open "System Preferences", select "Privacy & Security" from the sidebar.
      step-2: In the "Screen & System Audio Recording" and "System Audio Recording Only" sections, turn on the switches for AIRI.
      step-2-note: If AIRI is not listed, please add it manually by clicking the "+" button and selecting AIRI from the Applications folder.
